module.exports = __webpack_public_path__ + "static/media/loader_animated_Light.620065c4.gif";